$(function () {
    slick_slider();
});

$(document).on("shopify:section:load", function () {
    slick_slider();
});

$(document).on("shopify:section:unload", function () {
  slick_slider();
});

$(document).on("shopify:section:select", function () {
  slick_slider();
});

$(document).on("shopify:section:deselect", function () {
  slick_slider();
});

function slick_slider() {
    //メインビジュアル
    $('.js-slider--mv').not(".slick-initialized").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 600,
      infinite: true,
      arrows: true,
      prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev c-slider__arrow--mvLeft"></div>',
      nextArrow: '<div class="c-slider__arrow c-slider__arrow--next c-slider__arrow--mvRight"></div>',
       dots: $('.p-mv__image.c-slider__image--mv').length > 1,
      dotsClass: 'c-slider__dots c-flex -jc-c -ai-c',
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
	        arrows: true,
            centerMode: false,
          }
        }
      ],
      centerMode:true,
      centerPadding:"25%",
    });


    //タグ
    $('.js-slider--tag').not(".slick-initialized").slick({
      speed: 300,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: true,
      prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev c-slider__arrow--tag"></div>',
      nextArrow: '<div class="c-slider__arrow c-slider__arrow--next c-slider__arrow--tag"></div>',
      dots: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      responsive: [
        {
          breakpoint: 769,
          settings: "unslick",
        },
      ],
    });

    //ブランド
    $('.js-slider--brand').not(".slick-initialized").slick({
      speed: 300,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev c-slider__arrow--brand"></div>',
      nextArrow: '<div class="c-slider__arrow c-slider__arrow--next c-slider__arrow--brand"></div>',
      dots: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      responsive: [
        {
          breakpoint: 769,
          settings: "unslick",
        },
      ],
    });

    //商品
    $('.js-slider--item').not(".slick-initialized").slick({
      speed: 300,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev c-slider__arrow--item"></div>',
      nextArrow: '<div class="c-slider__arrow c-slider__arrow--next c-slider__arrow--item"></div>',
      dots: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 769,
          settings: "unslick",
        },
      ],
    });

    //商品詳細
    const productSlider = $('.js-slider--product');
    const productSliderThumbnail = $('.js-slider--productThum');

    productSlider.not(".slick-initialized").slick({
      fade: false,
      speed: 300,
      arrows: true,
      prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev c-slider__arrow--productLeft"></div>',
      nextArrow: '<div class="c-slider__arrow c-slider__arrow--next c-slider__arrow--productRight"></div>',
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    productSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      productSliderThumbnail.removeClass('current');
      productSliderThumbnail.eq(nextSlide).addClass('current');
    });

    productSliderThumbnail.each(function(index){
      $(this).attr('data-number', index);
    });
    productSliderThumbnail.eq(0).addClass('current');

    productSliderThumbnail.on('click', function(){
      var number = $(this).attr('data-number');
      productSlider.slick('slickGoTo', number, false,);
      $(this).siblings().removeClass('current');
      $(this).addClass('current');
    });
  setTimeout(function () {
    const sliders = document.querySelectorAll(".c-slider");
    sliders.forEach((slider) => {
      slider.classList.add("is-visible");
    });
  }, 100);
}

$(window).on('resize orientationchange', function() {
  $('.js-slider--mv').slick('resize');
  $('.js-slider--tag').slick('resize');
  $('.js-slider--brand').slick('resize');
  $('.js-slider--item').slick('resize');
  $('.js-slider--styling').slick('resize');
  $('.js-slider--product').slick('resize');
  $('#js-recentlySliderBody').slick('resize');
});